module.exports = __webpack_public_path__ + "img/unu@3x.69f43d74.png";